import React from "react";
import { Label } from "@src/common/components";

interface RequiredItemLabelProps {
  children: React.ReactNode;
  required?: boolean;
}

/** Item-row labels: bare when optional, red asterisk when required. */
export function RequiredItemLabel({
  children,
  required = false,
}: RequiredItemLabelProps) {
  return (
    <Label>
      {children}
      {required && <span className="text-red-500 shrink-0"> *</span>}
    </Label>
  );
}
